import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { IADTemplate } from "../../models/IADTemplate";
import { ICategory } from  "../../models/ICategory";
import { ISample } from "../../models/ISample";
import { IQuestion } from "../../models/IQuestion";
import { IQuota } from "../../models/IQuota";
import { IQuotaTable } from "../../models/IQuotaTable";
import { IAnswer } from "../../models/IAnswer";
import { IS1Question } from "../../models/IS1Question";
import { IS1Answer } from "../../models/IS1Answer";
import { IResearchCategory } from "../../models/IResearchCategory";
import { ITarget } from "../../models/ITarget";
import { FezaDataService } from '../../services/fezadata.service';
import { S1DataService} from '../../services/s1data.service';

@Component({
  selector: 'target-editor',
  templateUrl: './target-edit.component.html',
  styleUrls: ['./target-edit.component.css']
})
export class TargetEditComponent implements OnInit, OnChanges {
  @Input() locales: string[];
  @Input() countryCode: string;
  @Input() researchCategories: Array<IResearchCategory>;
  @Input() researchType: string;
  @Input() targets: ITarget[];
  @Output() onChanged: EventEmitter<ITarget[]> = new EventEmitter<ITarget[]>();
  @Output() onChangedQuotas: EventEmitter<IQuotaTable[]> = new EventEmitter<IQuotaTable[]>();
  @Output() onSampleCategoryChanged : EventEmitter<number> = new EventEmitter<number>();
  templates$: Observable<IADTemplate[]>;
  targetQuotas: IQuotaTable[] = null;
  categories: ICategory[];
  currentTemplate: IADTemplate; //used to build new target
  pickedTemplate: IADTemplate; //used in select to get current template id & details
  ageMin: number;
  ageMax: number;
  males: boolean = true;
  females: boolean = true;

  genderQuestion: IS1Question;
  genderAnswers: IS1Answer[];

  constructor(private fezaService: FezaDataService, private s1Service: S1DataService) {
    this.categories = [];
    this.genderAnswers = [];
    this.genderQuestion = null;
  }

  ngOnInit() {
    if (!this.ageMin && !this.ageMax) {
      this.ageMin = 1;
      this.ageMax = 100;
    }
    this.s1Service.getCategories().subscribe(cats => {
      this.categories = cats.filter(c => c.categoryType === 3);
      this.setTemplateList();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    //loading up existing target
    this.locales = this.locales || [];
    this.countryCode = this.countryCode || "";
    this.researchCategories = this.researchCategories || [];
    this.researchType = this.researchType || "";
    this.targets = this.targets || [];
    for (let propName in changes) {
      let change = changes[propName];
      if ((propName === "targets" && this.targetQuotas === null && this.targets) || propName === "locales") {
        //here is where I should parse the current target to set the age & gender inputs...
        this.setInputsFromTargets(this.targets);
        this.targetQuotas = this.targetAsQuotas(this.targets);
        this.getGenderQuestions();
      }
    }
    this.setTemplateList();
  }

  setTemplateList() {
    this.templates$ = this.fezaService.getAdTemplates(this.countryCode, this.locales, this.researchType);
    if (this.pickedTemplate != null) {
      //the picked a template, but then changed options such that one is available.
      this.templates$.subscribe(templates => {
        if ((templates.length === 0 && this.currentTemplate !== null) ||
          this.currentTemplate.id !== this.pickedTemplate.id) {
          this.currentTemplate = this.pickedTemplate = null;
          this.setTargetWithCurrentTemplate();
        }
      });
    }
  }

  getGenderQuestions() {
    if (this.locales && this.locales.length > 0 && this.locales[0].length > 0) {
      this.s1Service.getQuestions(this.locales[0]).subscribe(serviceQuestions => {
        for (let q of serviceQuestions) {
          if (q.name.toLowerCase() === "resp_gender") {
            this.s1Service.getAnswers(q.id).subscribe(ans => {
              this.genderAnswers = ans;
              this.genderQuestion = { id: q.id } as IS1Question;
              if (this.currentTemplate != null)
                this.setTargetWithCurrentTemplate();
            });
          }
        }
      });
    }
  }

  setInputsFromTargets(targets: ITarget[]) {
    this.males = this.females = false;

    var minAgeTarget = -1;
    var maxAgeTarget = -1;

    for (let target of targets) {
      for (let question of target.questions) {
        if (question.id === -1) {
          for (let a of question.answers) {
            if (a.rangeEnd != null && a.rangeStart != null) {              

              if (minAgeTarget == -1) minAgeTarget = parseInt(a.rangeStart);
              else minAgeTarget = minAgeTarget > parseInt(a.rangeStart) ? parseInt(a.rangeStart): minAgeTarget;
              
              if (maxAgeTarget == -1) maxAgeTarget = parseInt(a.rangeEnd);
              else maxAgeTarget = maxAgeTarget < parseInt(a.rangeEnd) ? parseInt(a.rangeEnd): maxAgeTarget;
            }
          }
        }
        if (this.genderQuestion != null && question.id === this.genderQuestion.id) {
          for (let ans of question.answers) {
            for (let genderAns of this.genderAnswers) {
              if (ans.id === genderAns.id && genderAns.name.toLowerCase() === "male") this.males = true;
              if (ans.id === genderAns.id && genderAns.name.toLowerCase() === "female") this.females = true;
            }
          }
        }
      }
    }

    if (minAgeTarget != -1) this.ageMin = minAgeTarget;
    if (maxAgeTarget != -1) this.ageMax = maxAgeTarget;

    if (!this.males && !this.females)
      this.males = this.females = true;
  }

  setInputsFromTemplate(template: IADTemplate) {
    this.currentTemplate = template;
    this.ageMin = this.currentTemplate.ageMin;
    this.ageMax = this.currentTemplate.ageMax;
    this.males = this.currentTemplate.percentMales > 0;
    this.females = this.currentTemplate.percentFemales > 0;
  }


  updateTemplate(newTemplate: IADTemplate = null) {
    this.currentTemplate = null;
    if (newTemplate != null) {
      this.fezaService.getADTemplate(newTemplate.id, this.locales[0]).subscribe(template => {
        this.setInputsFromTemplate(template);
        this.setTargetWithCurrentTemplate();
      });
    } else
      this.setTargetWithCurrentTemplate();
  }

  onEditMin() {
    if (this.ageMax < this.ageMin)
      this.ageMax = this.ageMin;
    this.setTargetWithEdit();
  }

  onEditMax() {
    if (this.ageMin > this.ageMax)
      this.ageMin = this.ageMax;
    this.setTargetWithEdit();
  }

  createDefaultTarget(ageMin: number, ageMax:number, males:boolean, females:boolean): ITarget[] {
    //returns the list gender & age targets when you clear out the 
    let targets: ITarget[] = [];
    targets.push({
      questions: [
        {
          id: -1,
          answers: [{ id: -1, rangeStart: ageMin.toString(), rangeEnd: ageMax.toString(), listId: null, text: null, answerText: null, listIdLastUpdatedDate: null }],
          operator: "OR",
          responseCode: "Ok",
          name: "Age Range"
        },
      ],
      isSampleUniverse: false
    });
    if ((males || females) && this.genderQuestion) {
      let gender = { id: this.genderQuestion.id, answers: [] } as IQuestion;
      for (let a of this.genderAnswers) {
        if (a.name.toLowerCase() === "female" && females)
          gender.answers.push({ id: a.id, rangeEnd: null, rangeStart: null, listId: null, text: null, answerText: null, listIdLastUpdatedDate:null });
        if (a.name.toLowerCase() === "male" && males)
          gender.answers.push({ id: a.id, rangeEnd: null, rangeStart: null, listId: null, text: null, answerText: null, listIdLastUpdatedDate: null });
      }
      targets.push({ questions: [gender],isSampleUniverse:false });
    }
    return targets;
  }

  createDefaultQuota(ageMin: number, ageMax: number): IQuotaTable[] {
    //returns a default quoats when you clear out your template.
    let quota = {
      quotaName: "Total",
      interviewType: "Completes",
      percentage: 100,
      questions: [{
        id: -1,
        answers: [{ id: -1, rangeStart: ageMin.toString(), rangeEnd: ageMax.toString() }],
        operator: "OR",
        name: "Age Range"
      }]
    } as IQuota;

    return [{
      quotas: [quota],
      tableName: "total"
    }];
  }

  setTargetWithCurrentTemplate() {
    //let's merges the current template target, gender target & age target
    let targets: ITarget[] = [];
    let quotas: IQuotaTable[] = [];
    if (this.currentTemplate) {

      this.onSampleCategoryChanged.emit(this.currentTemplate.sampleCategoryId);

      if (this.currentTemplate.sampleUniverse && !jQuery.isEmptyObject(this.currentTemplate.sampleUniverse)) {
        targets.push(Object.assign({}, JSON.parse(JSON.stringify(this.currentTemplate.sampleUniverse ))) as ITarget);
      }

      if (this.currentTemplate.targetStructure && !jQuery.isEmptyObject(this.currentTemplate.targetStructure)) {
        targets.push(Object.assign({}, JSON.parse(JSON.stringify(this.currentTemplate.targetStructure))) as ITarget);
      }

      if (this.currentTemplate.quotaStructure && !jQuery.isEmptyObject(this.currentTemplate.quotaStructure)) {
        quotas = this.currentTemplate.quotaStructure;
      }
    }
    else {
      //if you unselect the template,  you get this.
      this.ageMin = 1;
      this.ageMax = 100;
      this.males = true;
      this.females = true;
      targets = this.createDefaultTarget(this.ageMin, this.ageMax, this.males, this.females);
      quotas = this.createDefaultQuota(this.ageMin, this.ageMax);
    }
    this.targetQuotas = this.targetAsQuotas(targets);
    this.onChanged.emit(targets);
    this.onChangedQuotas.emit(quotas);
  }

  setTargetWithEdit() {
    //let's merges the current template target, gender target & age target
    let targets: ITarget[] = [];
    targets = this.createDefaultTarget(this.ageMin, this.ageMax, this.males, this.females);
    this.targetQuotas = this.targetAsQuotas(targets);
    this.onChanged.emit(targets);
  }

  targetAsQuotas(targets: ITarget[]) : IQuotaTable[] {
    let targetList = []; // we keep a copy of the target as a quota for the quota viewer
    for (let t of targets) {
      targetList.push({
        tableName: "Target",
        quotas: [{ quotaName: "Target", questions: t.questions, interviewType: "completes" }]
      } as IQuotaTable);
    }
    return targetList;
  }

  toggleMales(val: boolean) {
    this.males = val;
    this.setTargetWithEdit();
  }

  toggleFemales(val: boolean) {
    this.females = val;
    this.setTargetWithEdit();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/target-edit/target-edit.component.ts